/**
 * Resolve the backend API base URL.
 *
 * Build-time env var (`REACT_APP_BACKEND_URL`) gets baked into the production
 * bundle. If that env var is stale or points to a different origin than the
 * page (e.g. custom-domain deploys like gynovate.in), all API calls would
 * fail. To make this resilient, we:
 *
 *   1. Check if `process.env.REACT_APP_BACKEND_URL` points to a DIFFERENT
 *      origin than the current page.
 *   2. If yes (and we're not on localhost/dev), fall back to same-origin
 *      (empty string → relative URLs → handled by nginx/ingress proxy).
 *   3. Otherwise use the env value as-is.
 *
 * This means the frontend works correctly on any deployment URL — preview,
 * custom domain, or emergent.host — without rebuilding.
 */
function resolveApiBase() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
  if (typeof window === 'undefined') return envUrl;
  try {
    if (!envUrl) return '';
    const envOrigin = new URL(envUrl).origin;
    const pageOrigin = window.location.origin;
    const isLocal = pageOrigin.includes('localhost') || pageOrigin.includes('127.0.0.1');
    // If env URL host differs from page host AND we're not on localhost dev,
    // fall back to same-origin so requests go through the deployment ingress.
    if (envOrigin !== pageOrigin && !isLocal) {
      // eslint-disable-next-line no-console
      console.info(`[api] env URL (${envOrigin}) differs from page (${pageOrigin}); using same-origin`);
      return '';
    }
  } catch {
    return '';
  }
  return envUrl;
}

export const API = resolveApiBase();

export const getUserPhone = () => {
  try {
    return JSON.parse(localStorage.getItem('gynovate_signup') || 'null')?.phone || '';
  } catch {
    return '';
  }
};
